import React, { useContext, useState, useEffect, useRef } from "react";
import { Typography, Stack, Box, Grid2 as Grid, Button, Divider } from "@mui/material";
import { useQuery } from "@apollo/client";
import moment from "moment";
//Srcs
import "../../Style/pageStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import {
  SelectSchool,
  SelectAcademicYear,
} from "../../Function/DynamicSelect";
import { GET_ACTIVE_ACADEMIC_YEAR } from "../../Schema/AcademicYear"

import StudentAndAttendanceRateReport from "./StudentAndAttendanceRateReport";

// icon
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { DownloadTableExcel } from "react-export-table-to-excel";


const Report = () => {
  // ===================== Change Language ==========================
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [academicYearVal, setAcademicYearVal] = useState({ id: "", title: "" });
  const [schoolVal, setSchoolVal] = useState({ id: "", title: "" });

  const { refetch: refetchAcademic } = useQuery(GET_ACTIVE_ACADEMIC_YEAR, {
    onCompleted: ({ getActiveAcademicYear }) => {
      setAcademicYearVal({
        id: getActiveAcademicYear?._id,
        title: getActiveAcademicYear?.academic_year
      });
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => { refetchAcademic() }, [])

  //========================= PRINT ======================
  const componentRef = useRef();

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="column">
        <Stack direction="row" spacing={2} className="page-header">
          <Stack direction="column" justifyContent="center">
            <Box className="slash" />
          </Stack>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems={`center`}
          >
            <Typography
              className={language === "kh" ? "page-title-kh" : "page-title"}
            >
              {t(`page-report`)}
            </Typography>
          </Stack>
        </Stack>
        <Stack mt={2}>
          <Divider />
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 2 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`academic_year`)}
            </Typography>
            <SelectAcademicYear
              selectedVal={academicYearVal}
              setSelectedVal={setAcademicYearVal}
              className="search-field"
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 2 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`school`)}
            </Typography>
            <SelectSchool
              selectedVal={schoolVal}
              setSelectedVal={setSchoolVal}
              className="search-field"
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 4, xl: 8 }}>

              <Stack direction="row" justifyContent="right">
                <DownloadTableExcel
                    // filename={`${moment().format("DD/MM/YYYY")}`}
                    filename={`${schoolVal?.title}`}
                    sheet={`${schoolVal?.title}`}
                    currentTableRef={componentRef.current}
                >
                  <Button
                    className="btn-create-style"
                    startIcon={
                      <PiMicrosoftExcelLogoFill className="icon-add" />
                    }
                  >
                    <Typography
                      className={language === "kh" ? "btn-txt-kh" : "btn-txt"}
                    >
                      {t("export")}
                    </Typography>
                  </Button>
                </DownloadTableExcel>
              </Stack>
          
          </Grid>
        </Grid>

        <Box sx={{ marginTop: "15px" }}>
          <StudentAndAttendanceRateReport academicYearId={academicYearVal?.id} schoolId={schoolVal?.id} componentRef={componentRef} academicYearTitle={academicYearVal?.title}/>
        </Box>

        

      </Box>
    </div>
  );
};

export default Report;
